import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { groupedFieldsStyle } from '../TransitionStyles';
import { validateMedicare } from '../ValidateFunctions';
import FileDrop from './FormInputs/FileDrop';
import NumberOnlyInput from './FormInputs/NumberOnlyInput';

FormMedicareWithFileDrop.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  fieldAttributes: PropTypes.object,
};

export default function FormMedicareWithFileDrop({ fieldName, focusedField, setFocusedField, fieldAttributes }) {
  const { control, getValues } = useFormContext();

  const fieldArrayMethods = useFieldArray({
    control,
    name: `${fieldName}.files`,
    keyName: '_id',
  });

  const onFileAdded = (files) => {
    files.forEach((res) => {
      fieldArrayMethods.append(res[0]);
    });
  };

  const onFileRemoved = (file) => {
    const fileToRemove = getValues(fieldName)?.files?.findIndex((f) => f.id === file.id);
    fieldArrayMethods.update(fileToRemove, file);
  };

  return (
    <Grid sx={{ backgroundColor: '#f1f3f4cc', ...groupedFieldsStyle }}>
      <Controller
        name={`${fieldName}.answer`}
        control={control}
        rules={{
          validate: (value) => validateMedicare(value),
        }}
        render={() => (
          <NumberOnlyInput
            fieldName={`${fieldName}.answer`}
            focusedField={focusedField}
            setFocusedField={setFocusedField}
            fieldAttributes={fieldAttributes}
          />
        )}
      />
      <Controller
        name={`${fieldName}.files`}
        control={control}
        render={() => (
          <FileDrop
            fieldAttributes={fieldAttributes}
            onFileRemoved={onFileRemoved}
            onFileAdded={onFileAdded}
            files={fieldArrayMethods.fields?.filter((f) => !f.deleteFlag) ?? []}
          />
        )}
      />
    </Grid>
  );
}
